module.exports = __webpack_public_path__ + "img/carret-top-gray.545a31ce.svg";